module.exports = __webpack_public_path__ + "img/013-monster-1.b6c8392a.png";